import React from 'react';
import DailyProfitMonitor from './DailyProfitMonitor';
import DashboardBottomLogo from "./DashboardBottomLogo.tsx";

interface QuickProfitMonitorProps {
  className?: string;
}

const QuickProfitMonitor: React.FC<QuickProfitMonitorProps> = ({ className = '' }) => {

  return (
      <div>
      <DailyProfitMonitor className={className} />
      <DashboardBottomLogo />
    </div>
  );
};

export default QuickProfitMonitor;
